import {AuthTokenDto} from './AuthTokenDto';
import {Page} from './Page';
import {Pagination} from './Pagination';
import Axios, {AxiosResponse} from 'axios';
import {ResponseError} from '@/entity/ResponseError';
import {Base, RemoveEmptyUtils} from 'pansx-utils';
import KeShangSelect from "@/views/KeShangSelect.vue";

export class SecurityRequestBase extends Base {
    // public static readonly url = '';
    // public static readonly url = 'http://192.168.99.242:39990';
    // public static url = 'http://kfk8sn1.yong-gang.cn:30039';
    // public static url = 'http://kfk8sn1.yong-gang.cn:31039';
    // public static url = 'http://testk8sn1.yong-gang.cn:30039';
    //todo:线上
    public static readonly url = 'https://yzks.yong-gang.cn';//正式
    // public static readonly url = 'https://yzkstest.yong-gang.cn'; //测试
    // public static readonly url = 'http://192.168.99.133:39990';
    // public static readonly url = 'https://192.168.99.249';
    // public static url = '';
    // public static  url ='';
    static readonly debugHost = '192.168.202.47';
    // static readonly debugHost = '10.89.13.242';
    static readonly debugUrl = `http://${SecurityRequestBase.debugHost}:39990`;
    // static readonly debugUrl = `http://${SecurityRequestBase.debugHost}:31039`;


    public static getAxios() {
        Axios.defaults.maxRedirects = 5;
        Axios.defaults.validateStatus = () => true;
        Axios.defaults.headers.post = {
            'Content-Type': 'application/json',
        };
        return Axios;
    }


    public static async postWithToken<T>(url: string, data?: T | any) {
        url = this.getUrl() + url;
        const headers = {
            'version': AuthTokenDto.version,
            'Content-Type': 'application/json',
            'Authorization': AuthTokenDto.getFromStorage().getAccessTokenWithBearer(),
        };
        RemoveEmptyUtils.removeEmptyString(data);
        const response: AxiosResponse<T> = await this.getAxios().post(url, JSON.stringify(data), {
            data, headers: headers,
        });
        await this.handleError(response);
        AuthTokenDto.hook(response);
        return response.data;
    }

    /*    public static async handleError(response: AxiosResponse<any>) {
            if (response.status !== 200) {
                const json = await response.data as ResponseError;
                let message = json.message;
                if (json.error === 'invalid_token') {
                    AuthTokenDto.logout();
                    message = '登录已过期,请重新登录!';
                } else if (response.status === 400) {
                    message = '参数错误,请填完表单' + message;
                }
                throw message;
            }
        }*/


    public static async handleError(response: AxiosResponse<any>) {
        if (response.status !== 200) {
            const json = await response.data as ResponseError;
            let message = json.message;
            if (message === '令牌校验失败') {
                //清除，并重定向回登录
                window.localStorage.removeItem("AuthToken");
                window.localStorage.removeItem("user");
                window.localStorage.removeItem("demo1");
                window.localStorage.removeItem("selectedCompanyInfo");
                window.localStorage.removeItem("companyList");
                window.localStorage.removeItem("appList");
            } else {
                if (json.error === 'invalid_token') {
                    AuthTokenDto.logout();
                    message = '登录已过期,请重新登录!';
                } else if (response.status === 400) {
                    message = '参数错误,请填完表单' + message;
                }
            }
            throw message;
        }
    }


    public static async getDataWithJwt<T>(url: string, data?: T | any) {

        const response: AxiosResponse = await this.getAxios().get(this.getFullUrl(url, data), {

            headers: {
                version: AuthTokenDto.version,
                Authorization: AuthTokenDto.getFromStorage().getAccessTokenWithBearer(),
            },
        });
        await this.handleError(response);
        AuthTokenDto.hook(response);
        return response.data;
    }

    public static async findAllPageWithToken<T>(url: string, p: Pagination, filter?: T | any): Promise<Page<T>> {
        // 拼接分页和过滤器为一个对象以便传值
        const data = await this.getAxios().get(this.getFullUrl(url), {
            params: {...p, ...filter},
            headers: {
                version: AuthTokenDto.version,
                Authorization: AuthTokenDto.getFromStorage().getAccessTokenWithBearer(),
            },
        });
        const page = data.data as Page<T>;
        return Page.of(page) as Page<T>;
    }

    public static async get(url: string,token: string) {
        url = this.mixUrl(url);
        const response: AxiosResponse = await this.getAxios().get(url, {
            headers: {
                'token': token,
            },
        });
        return response;
    }


}


